export const YOUTUBE_IMAGE_URL_PREFIX = 'https://img.youtube.com/vi/';

export const YOUTUBE_IMAGE_VARIATIONS = ['/maxresdefault.jpg'];
